import styled from "styled-components";

export const NotesIconWrapper = styled.div`
  width: 14px;
  height: 14px;
`;
